import React from "react";
import { Box, Divider, Typography } from "@mui/material";
import { CampaignResponseView } from "../../../../pages/CampaignPage.types";
import { TruncateTooltip } from "../../../../components";

interface DetailsViewProps {
  details: CampaignResponseView | undefined;
}

function DetailsView(props: DetailsViewProps) {
  const { details } = props;

  return (
    <>
      <Divider />
      <Box mt={6} display="flex" flexDirection="column">
        <Box display="flex" gap={20} alignItems="center" mb={4}>
          <Box flex="0 0 150px">
            <Typography variant="label1" component="div" color="grey">
              Campaign name
            </Typography>
          </Box>
          <Box minWidth={0}>
            <TruncateTooltip>
              <Typography
                variant="label1"
                fontWeight="bold"
                component="div"
                color="grey"
                noWrap
              >
                {details?.name}
              </Typography>
            </TruncateTooltip>
          </Box>
        </Box>
        <Box display="flex" gap={20} alignItems="center" mb={4}>
          <Box flex="0 0 150px">
            <Typography variant="label1" component="div" color="grey">
              Subject
            </Typography>
          </Box>
          <Box minWidth={0}>
            <TruncateTooltip>
              <Typography
                variant="label1"
                fontWeight="bold"
                component="div"
                color="grey"
                noWrap
              >
                {details?.subject}
              </Typography>
            </TruncateTooltip>
          </Box>
        </Box>
        {details?.preview && (
          <Box display="flex" gap={20} alignItems="center">
            <Box flex="0 0 150px">
              <Typography variant="label1" component="div" color="grey">
                Preview text
              </Typography>
            </Box>
            <Box minWidth={0}>
              <TruncateTooltip>
                <Typography
                  variant="label1"
                  fontWeight="bold"
                  component="div"
                  color="grey"
                  noWrap
                >
                  {details?.preview}
                </Typography>
              </TruncateTooltip>
            </Box>
          </Box>
        )}
      </Box>
    </>
  );
}

export default DetailsView;
